import DesignTokens from '@tableau/design-tokens';
import { SpotUserGroupSetIconRaw } from '@tableau/icons/SpotUserGroupSetIcon/raw';

import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { ContentTypeFilterClause, ExplorableItemDefinition, SpaceDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { GroupSetContentType } from '~src/spacesPlatform/models/ContentTypes';
import { applyColor } from '~src/style/ColorService';
import { GroupSets } from '~src/userManagement/groupsets/GroupSets';

import { getNoDefaultFilters } from '../../../../spacesPlatform/contentDefinitions/getDefaultFilters';

export const GroupSetsDefinition: ExplorableItemDefinition & SpaceDefinition<'groupset'> = {
    itemType: 'group',
    contentType: 'groupset',
    singularName: Messages.groupSet,
    pluralName: Messages.groupSets,
    emptyStateMessage: Messages.groupSetsEmptyMessage,
    contentFilterKeys: GroupSetContentType.filterKeys,
    defaultFilters: getNoDefaultFilters,
    cardComponent: GenericCard,
    listViewIconType: null,
    headerIconPath: () => {
        return `data:image/svg+xml,${encodeURIComponent(SpotUserGroupSetIconRaw(60, applyColor(DesignTokens.color.font.default.default, CommonStyles.Colors.NormalTextColor)))}`;
    },
    filterClause: ServerFilterClauses.ContentType(['group']) as ContentTypeFilterClause,
    getBasicQuery: () => {
        return GroupSets.all();
    },
    getContentInfo: () => {
    },
    contentSpaceUrl: () => '',
    supportedDisplayModes: ['list'],
};